import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { SingleSelectorTreeViewComponent } from './single-selector-tree-view/single-selector-tree-view.component';
import { SingleSelectorComponent } from './single-selector.component';

@NgModule({
  declarations: [
    SingleSelectorTreeViewComponent,
    SingleSelectorComponent,
  ],
  imports: [    
    CommonModule,
    TreeViewModule
  ],
  exports:[
    SingleSelectorComponent
  ],
  entryComponents: [SingleSelectorComponent],
})
export class SingleSelectorModule { }
